import { render, staticRenderFns } from "./AppointmentDetails.vue?vue&type=template&id=b7ad505e&scoped=true"
import script from "./AppointmentDetails.vue?vue&type=script&lang=js"
export * from "./AppointmentDetails.vue?vue&type=script&lang=js"
import style0 from "./AppointmentDetails.vue?vue&type=style&index=0&id=b7ad505e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ad505e",
  null
  
)

export default component.exports